import {
    Button,
    Card, CardContent, CardHeader,
    Dialog, DialogActions, DialogContent, DialogTitle,
    Divider,
    Grid,
    IconButton,
    Input,
    Paper,
    Typography
} from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import AddIcCallIcon from '@material-ui/icons/AddIcCall';
import ClearAllIcon from '@material-ui/icons/ClearAll';
import CloseIcon from '@material-ui/icons/Close';
import LibraryAddIcon from '@material-ui/icons/LibraryAdd';
import SendIcon from '@material-ui/icons/Send';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import logger from 'src/utils/logger';
// Import
import 'react-confirm-alert/src/react-confirm-alert.css';
import { connect } from 'react-redux';
import { useHistory } from 'react-router';
import Alert from 'src/components/Alert';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';
import { loadBaslandiJob } from 'src/utils/storage/StartWorkOrder';
import CustomerPermision from './Summary/CustomerPermision';

const useStyles = makeStyles((theme) => ({
    root: {},
    fields: {
        margin: theme.spacing(-1),
        display: 'flex',
        flexWrap: 'wrap',
        '& > *': {
            flexGrow: 1,
            margin: theme.spacing(1)
        }
    },
    policy: {
        display: 'flex',
        alignItems: 'center'
    },
    policyCheckbox: {
        marginLeft: '-14px'
    },
    submitButton: {
        marginTop: theme.spacing(2),
        width: '100%'
    },
    content: {
        minHeight: 430,
    },
    divider: {
        backgroundColor: '#FF9800'
    },
    searchInputCC: {
        flexGrow: 1
    },
    searchCC: {
        flexGrow: 1,
        height: 42,
        padding: theme.spacing(0, 2),
        display: 'flex',
        alignItems: 'center'
    },
    searchIconCC: {
        marginRight: theme.spacing(0),
        color: theme.palette.icon
    },
}));

function Insurance({ className, FisNo, readonly, tasks }) {
    const classes = useStyles();
    const [uyari, setUyari] = useState(false);
    const [uyariTip, setUyariTip] = useState();
    const [uyariAciklama, setUyariAciklama] = useState('');
    const [LoadingControl, setLoadingControl] = useState(false);
    const [InsuranceTeklifDetay, setInsuranceTeklifDetay] = React.useState([]);
    const [FilterPaper, setFilterPaper] = useState('');
    const [InsurancePayPopupOpen, setInsurancePayPopupOpen] = useState(false);
    const [openEdit, setOpenEdit] = useState(false);
    const [sendPhoneNumber, setSendPhoneNumber] = useState("");

    const [selectedId, setSelectedId] = useState(null);
    const [selectedAd, setSelectedAd] = useState("");
    const [selectedTutar, setSelectedTutar] = useState(null);
    const [smsParams, setSmsParams] = useState(null);

    const history = useHistory();

    let InsuranceData = readonly ? (Array.isArray(tasks?.tasks) ? tasks.tasks.filter(d => parseInt(d.FisNo) === parseInt(FisNo)) : []) : loadBaslandiJob();
    let MusteriNo = InsuranceData[0]?.MusteriNo;
    let ModelAnaGrupKodu = InsuranceData[0]?.UST_MODEL_KODU;
    var KulModelKodu = InsuranceData[0]?.KUL_MODEL_KODU;
    var UyilRaw = InsuranceData[0]?.UYIL?.toString() || '';
    var Uyil = UyilRaw.length > 2 ? UyilRaw.substring(2) : UyilRaw;
    var Udonem = InsuranceData[0]?.UDONEM?.toString().padStart(2, '0');
    var SeriNo = InsuranceData[0]?.SERINO;
    var NitelikKodu = InsuranceData[0]?.NITELIK_KODU;
    var DurumKodu = InsuranceData[0]?.DurumKodu;
    const BARKOD = (KulModelKodu || '') + (Uyil || '') + (Udonem || '') + (SeriNo || '') + (NitelikKodu || '');
    
    // DurumKodu kontrolü: sadece 1, 3, 8, 28 durumlarında aktif
    const isDurumKoduValid = [1,3,4,5,8,25,28,64].includes(parseInt(DurumKodu));
    const isInsuranceActive = readonly && isDurumKoduValid;


    const SorgulaPolicyFind = (FisNo, ModelAnaGrupKodu, KulModelKodu) => {
        setLoadingControl(true);
        const dataSetPolicy = {
            MODEL_ANA_GRUP_KODU: ModelAnaGrupKodu,
            MODEL_KODU: KulModelKodu,
            FIS_NO: FisNo,
        };
        const configSetPolicy = {
            headers: { 'Content-Type': 'application/json' }
        };
        axios.post('/GetPolicyFind', dataSetPolicy, configSetPolicy)
            .then(response => {
                const result = response.data;

                if (!result.Successful || !result.Policies || result.Policies.length === 0) {
                    setInsuranceTeklifDetay([]);
                    setUyariTip("error");
                    setUyariAciklama("Müşterimiz için uygun sigorta teklifi bulunamadı!");
                    setUyari(true);
                } else {
                    setInsuranceTeklifDetay(result.Policies);
                }

                setLoadingControl(false);
            })
            .catch(error => {
                logger.error("GetPolicyFind hata:", error);
                setInsuranceTeklifDetay([]);
                setUyariTip("error");
                setUyariAciklama("Sigorta sorgulanırken bir hata oluştu!");
                setUyari(true);
                setLoadingControl(false);
            });
    };


    useEffect(() => {
        if (isInsuranceActive) {
            SorgulaPolicyFind(FisNo, ModelAnaGrupKodu, KulModelKodu);
        }
    }, [FisNo, ModelAnaGrupKodu, KulModelKodu, isInsuranceActive]);

    const uyariKapat = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setUyari(false);
    };

    const handleSmsGonderSmsAl = (
        Telefon,
        tip,
        FisNo,
        Musteri,
        TelefonOffline,
        MarkaKodu
    ) => {
        if (!isInsuranceActive) return;

        setLoadingControl(true);
        var Marka = '';

        const codigoMarca = parseInt(MarkaKodu);
        if (codigoMarca === 3) {
            Marka = 'Arçelik';
        } else if (codigoMarca === 4) {
            Marka = 'Beko';
        } else if (codigoMarca === 18) {
            Marka = 'Altus';
        } else if (codigoMarca === 28) {
            Marka = 'Grundig';
        } else {
            Marka = 'Arçelik';
        }
        const SessionUser = getUser();

        const data = [
            {
                FisNo: FisNo,
                Musteri: Musteri,
                Telefon: TelefonOffline,
                Tutar: selectedTutar,
                Marka: Marka,
                KullaniciId: SessionUser.OrganizationUserId,
                BirimKodu: SessionUser.ServiceShopId.toString(),
                SigortaStokNo: selectedId,
                SigortaTipi:selectedAd,
                TeknisyenKodu: SessionUser.TechnicianId.toString(),
                GrupNo: "14",
                ModelAciklama: InsuranceData[0]?.MODEL,
                Barkod: BARKOD,
                ModelAnaGrupKodu: ModelAnaGrupKodu,
                ModelKodu: KulModelKodu
            }
        ];
        const config = {
            headers: { 'Content-Type': 'application/json' }
        };
        axios
            .post('/SetInsurancePaySmsOdeme', JSON.stringify(data), config)
            .then(response => {
                setLoadingControl(false);
                setInsurancePayPopupOpen(false);
                const res = response.data;
                if (res !== 'ok') {
                    setUyariTip('error');
                    setUyariAciklama(res);
                } else {
                    setUyariTip('success');
                    setUyariAciklama('Sms Ödeme Linki Gönderildi!...');
                }
                setUyari(true);
            });
    };

    const ChangeFilter = value => {
        value = value?.replaceAll(' ', '');
        if (value.substring(0, 1) === '0') {
            value = value.substring(1, value.length);
        }
        setFilterPaper(value);
    };

    const handleClosePayPopupOpen = () => {
        setInsurancePayPopupOpen(false);
    };

    const handleEditClose = () => {
        setOpenEdit(false);
    };

    const [step, setStep] = React.useState(0);
    const [otp, setOtp] = React.useState(["", "", "", "", "", ""]);
    const [otpError, setOtpError] = React.useState("");
    const [, setSeconds] = React.useState(0);
    const [, setSmsSent] = React.useState(false);
    const [, setSmsSentCount] = React.useState(0);
    const inputRefs = React.useRef([]);


    const handleOtpChange = (value, index) => {
        if (!/^\d?$/.test(value)) return;

        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);

        if (value && index < 5) {
            inputRefs.current[index + 1].focus();
        }
    };

    const handleOtpKeyDown = (e, index) => {
        if (e.key === "Backspace" && !otp[index] && index > 0) {
            inputRefs.current[index - 1].focus();
        }
    };

    const verifyOtp = () => {
        if (!isInsuranceActive) return;

        const code = otp.join("");

        if (code.length !== 6) {
            setOtpError("Lütfen 6 haneli onay kodunu giriniz.");
            return;
        }

        setOtpError("");

        const dataVerify = [
            {
            phone: sendPhoneNumber, // SMS gönderdiğin numara
            code: code,
        }];

        const configVerify = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        axios
            .post("/SmsVerifyPermisionforInsurance", dataVerify, configVerify)
            .then((response) => {
                const { ErrorCode, ErrorDescription } = response.data;

                if (ErrorCode === "1000") {
                    // ✅ Doğrulama başarılı
                    setUyariAciklama(ErrorDescription);
                    setUyariTip("success");
                    setUyari(true);
                    
                    // SMS onayı başarılı, şimdi ödeme linkini gönder
                    if (smsParams) {
                        handleSmsGonderSmsAl(
                            smsParams.Telefon,
                            smsParams.tip,
                            smsParams.FisNo,
                            smsParams.Musteri,
                            smsParams.TelefonOffline,
                            smsParams.MarkaKodu
                        );
                    }
                    
                    handleClosePayPopupOpen();
                    setStep(0);
                } else {
                    // ❌ Hatalı / süresi dolmuş
                    setOtpError(ErrorDescription);
                }
            })
            .catch(() => {
                setOtpError("Doğrulama sırasında bir hata oluştu.");
            });
    };



    const smsSend = (
        event,
        Telefon,
        tip,
        FisNo,
        Musteri,
        TelefonOffline,
        MarkaKodu
    ) => {
        if (!isInsuranceActive) {
            alert("Sigorta işlemleri montaj tamamlandıktan sonra yapılabilir!");
            return;
        }

        const smsText = "";
        setSendPhoneNumber(TelefonOffline);
        let Marka = "";

        if (!TelefonOffline || TelefonOffline.length < 10) {
            alert("Lütfen geçerli bir telefon numarası giriniz.");
            return;
        }

        if (!KulModelKodu || !Uyil || !Udonem || !SeriNo) {
            alert("Lütfen Ürün bilgilerini doldurun.");
            history.push(`/WorkOrder/${FisNo}/Urun`);
            return;
        }

        let TutarDeger = selectedTutar;

        const Uyari =
            Musteri +
            " ın " +
            TelefonOffline +
            " numaralı telefonuna onay kodu gönderilecek ve sonrasında ödeme linki ile " +
            TutarDeger.toString() +
            " TL ödeme alınacaktır. Devam etmek ister misiniz?";

        const confirmation = window.confirm(Uyari);
        if (!confirmation) return;

        Marka = parseInt(MarkaKodu) === 4 ? "Beko" : "Arçelik";

        // Parametreleri state'e kaydet
        setSmsParams({
            Telefon,
            tip,
            FisNo,
            Musteri,
            TelefonOffline,
            MarkaKodu
        });

        const dataPermision = [
            {
                smsText: smsText,
                Phone: TelefonOffline,
                Brand: Marka,
                CustomerNr: MusteriNo,
                ServicePaperNr: FisNo,
                TextType: tip
            }
        ];

        const configPermision = {
            headers: { "Content-Type": "application/json" }
        };

        setSmsSent(true);
        setSmsSentCount((prev) => prev + 1);

        axios
            .post("/SmsSendPermisionforInsurance", dataPermision, configPermision)
            .then((response) => {
                if (response.data && response.data.length > 10) {
                    setUyariAciklama("SMS müşteriye iletildi.");
                    setUyariTip("success");

                    // 🔥 OTP ADIMINA GEÇ
                    setStep(1);

                    // 🔥 OTP RESET
                    setOtp(["", "", "", "", "", ""]);
                    setOtpError("");

                } else {
                    setUyariAciklama("SMS sunucu kaynaklı iletilemedi.");
                    setUyariTip("error");
                }

                setUyari(true);
                setSeconds(30);
                setTimeout(() => setSmsSent(false), 30000);
            })
            .catch(() => {
                setUyariAciklama("İç sunucu hatası nedeniyle SMS gönderilemedi.");
                setUyariTip("error");
                setSmsSent(false);
                setUyari(true);
            });
    };

    const formatInsuranceName = (name) => {
        if (!name) return name;
        
        const upperName = name.toUpperCase();
        let formattedName = name;
        
        if (upperName.includes('1+2')) {
            formattedName = name.replace(/1\+2\s*YIL/gi, '1 Yıl Sigorta + 2 Yıl Ek Garanti');
        } else if (upperName.includes('1+1')) {
            formattedName = name.replace(/1\+1\s*YIL/gi, '1 Yıl Sigorta + 1 Yıl Ek Garanti');
        } else if (upperName.includes('1 YIL') || upperName.includes('1YIL')) {
            formattedName = name.replace(/1\s*YIL/gi, '1 Yıl Sigorta');
        }
        
        // "TV" ile başlayan kısımdan itibaren sil
        const tvIndex = formattedName.toUpperCase().indexOf(' TV');
        if (tvIndex !== -1) {
            formattedName = formattedName.substring(0, tvIndex);
        }
        
        return formattedName.trim();
    };

    // HIZMETLER içinde KUL_HIZMET_KODU: 554 veya 600 olup olmadığını kontrol et
    const hasProhibitedService = Array.isArray(InsuranceData[0]?.HIZMETLER) && 
        InsuranceData[0].HIZMETLER.some(h => h.KUL_HIZMET_KODU === "554" || h.KUL_HIZMET_KODU === 554 || h.KUL_HIZMET_KODU === "600" || h.KUL_HIZMET_KODU === 600);


    return (
        <Card className={clsx(classes.root, className)}>
            <CardHeader title={"Sigorta Teklif"} />
            <Divider />
            {
                uyari ?
                    <Alert onClose={uyariKapat} open={uyari} message={uyariAciklama || ''} variant={uyariTip} />
                    : <div></div>
            }
            <CardContent className={classes.content}>
                {
                    !isInsuranceActive ? (
                        <Grid container spacing={0}>
                            <Grid item xs={12}>
                                <Typography variant="h6" gutterBottom color="error">
                                    Sigorta işlemleri montaj tamamlandıktan sonra yapılabilir!
                                </Typography>
                            </Grid>
                            <Grid item xs={12} align={'center'}>
                                <IconButton color="secondary" alignItems="center">
                                    <ClearAllIcon size="large" />
                                </IconButton>
                            </Grid>
                        </Grid>
                    ) : LoadingControl ?
                        <CircularProgress
                            status={'loading'}
                            style={{ marginLeft: '50%' }}
                        />
                        :
                        hasProhibitedService ?
                        <Grid container spacing={0} >
                            <Grid item xs={12}>
                                <Typography variant="h6" gutterBottom color="error">
                                    Değişen Ürünlere sigorta satışı yapılamaz!
                                </Typography>
                            </Grid>
                            <Grid item xs={12} align={'center'}>
                                <IconButton
                                    color="primary"
                                    alignItems="center">
                                    <ClearAllIcon size="large" />
                                </IconButton>
                            </Grid>
                        </Grid>
                        :
                        InsuranceTeklifDetay.length === 0 ?
                            <Grid container spacing={0} >
                                <Grid item xs={12}>
                                    <Typography variant="h6" gutterBottom>
                                        Müşterimizin Sigorta Teklif edilebilecek ürünü bulunmamaktadır!...
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} align={'center'}>
                                    <IconButton
                                        color="primary"
                                        alignItems="center">
                                        <ClearAllIcon size="large" />
                                    </IconButton>
                                </Grid>
                            </Grid>
                            :
                            <>
                                {/* --- TV Ürün Bilgisi --- */}
                                <Card variant="outlined" style={{ marginBottom: 16, padding: 16 }}>
                                    <Typography variant="subtitle1" gutterBottom>
                                        <b>Ürün Bilgisi</b>
                                    </Typography>
                                    <Typography><b>Marka:</b> {InsuranceData?.[0]?.Marka}</Typography>
                                    <Typography><b>Model:</b> {InsuranceData?.[0]?.MODEL}</Typography>
                                    <Typography><b>Garanti Tarihi:</b> {InsuranceData?.[0]?.GARANTI_TARIHI}</Typography>
                                </Card>
                                <Typography
                                    variant="h6"
                                    style={{ fontWeight: "bold", marginBottom: "16px" }}
                                >
                                    Önerilen Sigorta Teklifleri
                                </Typography>

                                <Grid container spacing={2}>
                                    {InsuranceTeklifDetay.sort((a, b) => { return a.KUL_MODEL_KODU - b.KUL_MODEL_KODU }).map(log => (
                                        <Grid item xs={12} sm={6} key={log.Id}>
                                            <Card 
                                                variant="outlined" 
                                                style={{ 
                                                    padding: '20px',
                                                    height: '100%',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    borderRadius: '12px',
                                                    border: '2px solid #FF9800',
                                                    transition: 'all 0.3s ease',
                                                    cursor: 'pointer',
                                                    position: 'relative',
                                                    background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)'
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.currentTarget.style.borderColor = '#F57C00';
                                                    e.currentTarget.style.transform = 'translateY(-4px)';
                                                    e.currentTarget.style.boxShadow = '0 8px 24px rgba(255, 152, 0, 0.25)';
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.currentTarget.style.borderColor = '#FF9800';
                                                    e.currentTarget.style.transform = 'translateY(0)';
                                                    e.currentTarget.style.boxShadow = 'none';
                                                }}
                                            >
                                                {/* Fixpack Logo */}
                                                <div style={{ 
                                                    position: 'absolute', 
                                                    top: '12px', 
                                                    right: '12px',
                                                    width: '80px',
                                                    height: 'auto'
                                                }}>
                                                    <img 
                                                        src="/images/fixpack-logo.jpg" 
                                                        alt="Fixpack"
                                                        style={{ 
                                                            width: '100%',
                                                            height: 'auto',
                                                            objectFit: 'contain'
                                                        }}
                                                        onError={(e) => {
                                                            // Eğer logo bulunamazsa text göster
                                                            e.target.style.display = 'none';
                                                            e.target.parentElement.innerHTML = '<div style="background: #FF9800; color: white; padding: 4px 12px; borderRadius: 12px; fontSize: 11px; fontWeight: bold;">FIXPACK</div>';
                                                        }}
                                                    />
                                                </div>

                                                {/* Fiyat */}
                                                <Typography
                                                    variant="h3"
                                                    style={{ 
                                                        fontWeight: '900',
                                                        color: '#2E7D32',
                                                        marginTop: '8px',
                                                        marginBottom: '16px',
                                                        display: 'flex',
                                                        alignItems: 'baseline',
                                                        gap: '4px'
                                                    }}
                                                >
                                                    {log.Tutar}
                                                    <span style={{ fontSize: '24px', fontWeight: '700' }}>₺</span>
                                                </Typography>

                                                {/* Ürün Adı */}
                                                <Typography
                                                    variant="h6"
                                                    style={{ 
                                                        fontWeight: '600',
                                                        color: '#212121',
                                                        marginBottom: '24px',
                                                        lineHeight: '1.4',
                                                        flex: 1
                                                    }}
                                                >
                                                    {formatInsuranceName(log.Ad)}
                                                </Typography>

                                                {/* Satış Yap Butonu */}
                                                <Button
                                                    fullWidth
                                                    variant="contained"
                                                    size="large"
                                                    disabled={!isInsuranceActive}
                                                    onClick={() => {
                                                        setSelectedId(log.Id); 
                                                        setSelectedAd(log.Ad);
                                                        setSelectedTutar(log.Tutar);
                                                        setInsurancePayPopupOpen(true);
                                                    }}
                                                    style={{
                                                        background: isInsuranceActive ? 'linear-gradient(135deg, #4CAF50 0%, #45a049 100%)' : '#ccc',
                                                        color: 'white',
                                                        fontWeight: 'bold',
                                                        fontSize: '15px',
                                                        padding: '12px',
                                                        borderRadius: '8px',
                                                        textTransform: 'none',
                                                        boxShadow: isInsuranceActive ? '0 4px 12px rgba(76, 175, 80, 0.3)' : 'none',
                                                        transition: 'all 0.3s ease'
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        if (isInsuranceActive) {
                                                            e.currentTarget.style.background = 'linear-gradient(135deg, #45a049 0%, #3d8b40 100%)';
                                                            e.currentTarget.style.boxShadow = '0 6px 16px rgba(76, 175, 80, 0.4)';
                                                        }
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        if (isInsuranceActive) {
                                                            e.currentTarget.style.background = 'linear-gradient(135deg, #4CAF50 0%, #45a049 100%)';
                                                            e.currentTarget.style.boxShadow = '0 4px 12px rgba(76, 175, 80, 0.3)';
                                                        }
                                                    }}
                                                >
                                                    <LibraryAddIcon style={{ marginRight: '8px' }} />
                                                    Satış Yap
                                                </Button>
                                            </Card>
                                        </Grid>
                                    ))}
                                </Grid>
                            </>
                }
            </CardContent>
            <Dialog
                open={InsurancePayPopupOpen}
                onClose={handleClosePayPopupOpen}
                fullWidth
                maxWidth="xs"
            >
                <DialogTitle>
                    {step === 0 ? "SMS Gönder" : "Onay Kodu Doğrulama"}
                </DialogTitle>
                <Divider />
                <DialogContent
                    dividers
                    style={{
                        minHeight: 280,
                        display: "flex",
                        flexDirection: "column",   // 🔥 EN KRİTİK SATIR
                        gap: 12,
                    }}
                >
                    {/* STEP 1 — SMS */}
                    {/* STEP 0 — SMS GÖNDER */}
                    {step === 0 && (
                        <>
                            <DialogContent
                                dividers
                                style={{
                                    minHeight: 280,
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 12,
                                }}
                            >
                                {/* TELEFON 1 */}
                                {InsuranceData[0]?.Telefon && (
                                    <Button
                                        fullWidth
                                        variant="contained"
                                        color="secondary"
                                        className={classes.submitButton}
                                        onClick={(event) =>
                                            smsSend(
                                                event,
                                                InsuranceData?.[0]?.Telefon,
                                                1,
                                                InsuranceData?.[0]?.FisNo,
                                                InsuranceData?.[0]?.Musteri,
                                                InsuranceData?.[0]?.TelefonOffline,
                                                InsuranceData?.[0]?.MARKA_KODU
                                            )
                                        }
                                        endIcon={<AddIcCallIcon />}
                                    >
                                        Telefon 1 : {InsuranceData?.[0]?.Telefon}
                                    </Button>
                                )}

                                {/* TELEFON 2 */}
                                {InsuranceData?.[0]?.Telefon2 && (
                                    <Button
                                        fullWidth
                                        variant="contained"
                                        color="secondary"
                                        className={classes.submitButton}
                                        onClick={(event) =>
                                            smsSend(
                                                event,
                                                InsuranceData?.[0]?.Telefon2,
                                                2,
                                                InsuranceData?.[0]?.FisNo,
                                                InsuranceData?.[0]?.Musteri,
                                                InsuranceData?.[0]?.Telefon2Offline,
                                                InsuranceData?.[0]?.MARKA_KODU
                                            )
                                        }
                                        endIcon={<AddIcCallIcon />}
                                    >
                                        Telefon 2 : {InsuranceData?.[0]?.Telefon2}
                                    </Button>
                                )}

                                {/* TELEFON 3 */}
                                {InsuranceData[0]?.Telefon3 && (
                                    <Button
                                        fullWidth
                                        variant="contained"
                                        color="secondary"
                                        className={classes.submitButton}
                                        onClick={(event) =>
                                            smsSend(
                                                event,
                                                InsuranceData?.[0]?.Telefon3,
                                                3,
                                                InsuranceData?.[0]?.FisNo,
                                                InsuranceData?.[0]?.Musteri,
                                                InsuranceData?.[0]?.Telefon3Offline,
                                                InsuranceData?.[0]?.MARKA_KODU
                                            )
                                        }
                                        endIcon={<AddIcCallIcon />}
                                    >
                                        Telefon 3 : {InsuranceData?.[0]?.Telefon3}
                                    </Button>
                                )}

                                {/* ARAYAN TELEFON */}
                                {InsuranceData[0]?.ArayanTelefon && (
                                    <Button
                                        fullWidth
                                        variant="contained"
                                        color="secondary"
                                        className={classes.submitButton}
                                        onClick={(event) =>
                                            smsSend(
                                                event,
                                                InsuranceData?.[0]?.ArayanTelefon,
                                                4,
                                                InsuranceData?.[0]?.FisNo,
                                                InsuranceData?.[0]?.Musteri,
                                                InsuranceData?.[0]?.ArayanTelefonOffline,
                                                InsuranceData?.[0]?.MARKA_KODU
                                            )
                                        }
                                        endIcon={<AddIcCallIcon />}
                                    >
                                        Arayan Telefon : {InsuranceData?.[0]?.ArayanTelefon}
                                    </Button>
                                )}

                                {/* İRTİBAT TELEFON */}
                                {InsuranceData[0]?.IrtibatTelefon && (
                                    <Button
                                        fullWidth
                                        variant="contained"
                                        color="secondary"
                                        className={classes.submitButton}
                                        onClick={(event) =>
                                            smsSend(
                                                event,
                                                InsuranceData?.[0]?.IrtibatTelefon,
                                                5,
                                                InsuranceData?.[0]?.FisNo,
                                                InsuranceData?.[0]?.Musteri,
                                                InsuranceData?.[0]?.IrtibatTelefonOffline,
                                                InsuranceData?.[0]?.MARKA_KODU
                                            )
                                        }
                                        endIcon={<AddIcCallIcon />}
                                    >
                                        İrtibat Telefon : {InsuranceData?.[0]?.IrtibatTelefon}
                                    </Button>
                                )}
                            </DialogContent>

                            {/* DİĞER TELEFON — ALTTA */}
                            <DialogActions>
                                <Paper
                                    elevation={1}
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        padding: "6px 12px",
                                        width: "100%",
                                    }}
                                >
                                    <Input
                                        fullWidth
                                        disableUnderline
                                        value={FilterPaper}
                                        onChange={(e) => ChangeFilter(e.target.value)}
                                        placeholder="Diğer Telefon (5xxxxxxxxx)"
                                    />
                                    <IconButton
                                        onClick={(event) =>
                                            smsSend(
                                                event,
                                                FilterPaper,
                                                6,
                                                InsuranceData?.[0]?.FisNo,
                                                InsuranceData?.[0]?.Musteri,
                                                FilterPaper,
                                                InsuranceData?.[0]?.MARKA_KODU
                                            )
                                        }
                                    >
                                        <SendIcon />
                                    </IconButton>
                                </Paper>
                            </DialogActions>
                        </>
                    )}

                    {/* STEP 2 — OTP */}
                    {step === 1 && (
                        <Grid container spacing={2} style={{ textAlign: "center" }}>

                            <Grid item xs={12}>
                                <Typography variant="body2" color="textSecondary">
                                    Telefonunuza gönderilen <b>6 haneli</b> onay kodunu giriniz
                                </Typography>
                            </Grid>

                            <Grid item xs={12}>
                                <div style={{ display: "flex", justifyContent: "center", gap: 10 }}>
                                    {otp.map((digit, index) => (
                                        <input
                                            key={index}
                                            ref={(el) => (inputRefs.current[index] = el)}
                                            value={digit}
                                            onChange={(e) =>
                                                handleOtpChange(e.target.value, index)
                                            }
                                            onKeyDown={(e) =>
                                                handleOtpKeyDown(e, index)
                                            }
                                            maxLength={1}
                                            style={{
                                                width: 44,
                                                height: 54,
                                                fontSize: 24,
                                                textAlign: "center",
                                                borderRadius: 8,
                                                border: "1px solid #ccc",
                                                outline: "none",
                                            }}
                                        />
                                    ))}
                                </div>
                            </Grid>

                            {otpError && (
                                <Grid item xs={12}>
                                    <Typography color="error">
                                        {otpError}
                                    </Typography>
                                </Grid>
                            )}

                            <Grid item xs={12}>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    fullWidth
                                    onClick={verifyOtp}
                                >
                                    Doğrula
                                </Button>
                            </Grid>

                            <Grid item xs={12}>
                                <Button
                                    size="small"
                                    onClick={() => {
                                        setStep(0);
                                        setOtp(["", "", "", "", "", ""]);
                                        setOtpError("");
                                    }}
                                >
                                    Geri Dön
                                </Button>
                            </Grid>
                        </Grid>
                    )}
                </DialogContent>
                <Divider />
                <DialogActions>
                    <Button
                        onClick={handleClosePayPopupOpen}
                        variant="contained"
                        color="secondary"
                        endIcon={<CloseIcon>Close</CloseIcon>}
                    >
                        Kapat
                    </Button>
                </DialogActions>
            </Dialog >
            <CustomerPermision
                customer={InsuranceData === undefined ? loadBaslandiJob()[0] : InsuranceData[0]}
                onClose={handleEditClose}
                open={openEdit}
            />
        </Card >
    );
}

Insurance.propTypes = {
    className: PropTypes.string,
};


export default connect(
    state => ({ tasks: state.tasks1 })
)(Insurance);
